export default __webpack_public_path__ + "static/tek-logo-video-dff997708128a88681b760bbd065b6ca.mp4";